import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0, 0, 2, 0),
    backgroundColor: 'inherit'
  }
}));

export const useNoDataClasses = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 0, 0, 3),
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightRegular
  }
}));

export const useToolBarStyles = makeStyles(theme => ({
  toolbar: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(0, 1, 0, 0)
  }
}));

export default useStyles;
